import AutoSelectMultiField from "./AutoSelectMultiField.mjs";
import appLib from "../../libs/appLib.mjs";
import TextLabel from "../../controls/TextLabel.mjs";

const AutoAtecoField = class extends AutoSelectMultiField {
	componentDidMount() {
		super.componentDidMount();
		appLib.getAtecoList().then( atecoList => {
			const opts = Object.entries(
				atecoList
			).sort(
				(a,b) => a[0].localeCompare(b[0])
			).map(
				([k,v]) => ( {value: `${k}`, label: `${k}: ${v}` } )
			);
			this.setState({ options: opts });
		})
	}
	renderField() {
		if ( this.state.options.length === 0) return <TextLabel value={"Loading…"} />;
		return super.renderField();
	}
}

export default AutoAtecoField;